import React from "react";
import { Controller } from "react-hook-form";
import { Uploader } from "rsuite";
import { Button } from "react-bootstrap";
import { Trans } from "react-i18next";
import "./CreateProfile.css";

function UploadProfileNewLayout({ fileOnChange, register, control }) {
  const uploader = React.createRef();

  return (
    <div className="">
      <div className="text-dark">
        <h6 className="fw-bold">
          <Trans
            defaults="Upload your resume to apply faster"
            i18nKey="uploadYourResumeToApplyFaster"
          />
        </h6>
      </div>
      <div className="d-flex  justify-content-center text-center">
        <Controller
          control={control}
          name={"UploadProfiles"}
          refs={register("UploadProfiles")}
          render={({ field: { onChange, onBlur, value } }) => (
            <Uploader
              action=""
              draggable
              multiple={false}
              autoUpload={false}
              onChange={(e) => {
                onChange(e);
                fileOnChange(e);
              }}
              accept=".doc, .docx, .pdf, .txt"
              fileListVisible={false}
              ref={uploader}
              className="uploader-container"
            >
              <div className="align-items-center justify-content-center d-flex">
                <div className="py-5 text-muted">
                  <div className="my-1 mb-2">
                    <b className="uploadText">
                      <Trans
                        i18nKey="clickToUpload"
                        defaults="Click To Upload"
                      />
                    </b>{" "}
                    <Trans i18nKey="or" defaults="or" />{" "}
                    <Trans
                      i18nKey="dragAndDropProfile"
                      defaults="Drag & Drop Profile Here"
                    />
                  </div>

                  <div>
                    <Trans
                      defaults="We accept only doc, docx, pdf and txt (MAX. 2 MB)"
                      i18nKey="formatSizeWarningMessages"
                    />
                  </div>
                </div>
              </div>
            </Uploader>
          )}
        />
      </div>
    </div>
  );
}

export default UploadProfileNewLayout;
